import { OnDestroy } from '@angular/core/core';
import { DataService } from './../../../../../core.module/services/data.service';
import { Subscription } from 'rxjs/Subscription';
import { RotationItem } from './../../../../../shared/sdk/models/RotationItem';
import { ScreenApi } from '../../../../../shared/sdk/index';
import { LoggerService } from './../../../../../shared/sdk/services/custom/logger.service';
import { SortablejsOptions } from 'angular-sortablejs/dist';
import { ScreenCategory } from './../../../../../shared/sdk/models/ScreenCategory';
import { Screen } from './../../../../../shared/sdk/models/Screen';
import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { DataURLS } from '../../../../../shared/base.url';
import { LoopBackConfig } from '../../../../../shared/sdk';


interface ScreenListObj {
  screen: Screen;
  selected: boolean;
}

@Component({
  selector: 'app-addscreen-dialog',
  templateUrl: './addscreen-dialog.component.html',
  styleUrls: ['./addscreen-dialog.component.css']
})
export class AddscreenDialogComponent implements OnInit, OnChanges, OnDestroy {
  public screens: Array<Screen> = new Array<Screen>(); // master list of all screens for this user
  public screenListObjs: Array<ScreenListObj> = new Array<ScreenListObj>(); // list of screens with any additional properties..
  public filteredScreenListObjs: Array<ScreenListObj> = new Array<ScreenListObj>(); // final filtered list
  public selectedScreens: Array<Screen> = new Array<Screen>(); // screens selected by the user


  public draggingObject: any;
  public watchScreenSub$: Subscription;
  public currentUserChange$: Subscription;
  public realtimeConnectionChange$: Subscription;
  public showScreenPicker: boolean;
  public loadingSceens: boolean;
  public dataConnected: boolean;

  @Output() onSelected = new EventEmitter();
  @ViewChild('filterInput') filterInput;

  public visibleVal: boolean;
  @Output() visibleChange = new EventEmitter();
  @Input()
  get visible() {
    return this.visibleVal;
  }

  set visible(val) {
    if (val) {
      // load data on first showing
      if (this.dataConnected && !this.watchScreenSub$) {
        this.watchScreens(); // load screens
      }

      // initilize on show
      this.selectedScreens = []; // clear selection list
      this.screenListObjs.forEach(screenListObj => { screenListObj.selected = false; }); // deselect everything
      this.filterInput.nativeElement.value = '';
    }

    this.visibleVal = val;
    this.visibleChange.emit(this.visibleVal);
  }

  constructor(
    public logger: LoggerService,
    public screenApi: ScreenApi,
    public dataService: DataService
  ) {
    LoopBackConfig.setBaseURL(DataURLS.BASE_URL);
    LoopBackConfig.setApiVersion(DataURLS.API_VERSION);
  }

  ngOnInit() {

    this.currentUserChange$ = this.dataService.currentUserChange$.subscribe((user) => {
      if (user && this.dataService.playerRTRef && this.visible) {
        this.watchScreens();
      }
    });

    this.realtimeConnectionChange$ = this.dataService.realtimeConnectionChange$.subscribe((data) => {

      this.dataConnected = data.connected; // save var for when screen is opened

      if (data.connected && this.visible) {
        this.watchScreens();
      }

      if (data.connecting) {
        this.loadingSceens = true;
      }
    });
  }

  ngOnDestroy() {
    if (this.currentUserChange$) {
      this.currentUserChange$.unsubscribe();
    }

    if (this.watchScreenSub$) {
      this.watchScreenSub$.unsubscribe();
    }

    if (this.realtimeConnectionChange$) {
      this.realtimeConnectionChange$.unsubscribe();
    }

  }

  ngOnChanges(changes: SimpleChanges) {

  }

  async watchScreens() {
    const myId = this.dataService.getCalculatedUserId();
    const curRole = await this.dataService.getCurrentRole();

    if (this.watchScreenSub$) {
      this.watchScreenSub$.unsubscribe();
    }

    // for Distributors, and Clients, match onwer by kanvasUserId, or parentContributorId
    const whereStr = <any>{

      libraryId: this.dataService.currentUser.privateLibrary.id

    };


    this.watchScreenSub$ = this.dataService.screenRTRef.on('change', {
      order: 'updatedAt DESC',
      where: whereStr,
      include: [{ 'library': [{ 'kanvasUserPrivateLibrary': 'roles' }, { 'kanvasUserPublicLibrary': 'roles' }] }, 'tags', 'playerGroups', 'rotationItems']
    }).subscribe((screens: Screen[]) => {
      if ((<any>screens).error) {
        this.logger.error((<any>screens).error);
      } else {

        const tempSelecttionList: Array<ScreenListObj> = [];

        this.screens = screens.map((scr: any): Screen => {

          // add empty list for player groups
          if (!scr.playerGroups) { scr.playerGroups = []; }

          // see if the screen was already in the list and selected.. if so select it when adding it to the new list
          const result = this.screenListObjs.find(slo => {
            if (slo.screen.id === scr.id && slo.selected) {
              return true;
            } else {
              return false;
            }
          });


          tempSelecttionList.push({ screen: scr, selected: result ? true : false });

          return scr;
        });

        // copy list to new screen list
        this.screenListObjs = tempSelecttionList.slice();

        // apply filters
        this.filterScreens(this.filterInput.nativeElement.value);

        this.loadingSceens = false;
      }
    }, err => {
      this.logger.error(`Error loading screens from data source!`, err);
    });
  }

  filterScreens(filtertext) {
    this.filteredScreenListObjs = this.screenListObjs.filter(screenListObj => {
        if (filtertext === '' || filtertext === null || screenListObj.screen.ScreenName && screenListObj.screen.ScreenName.toLowerCase().indexOf(filtertext.toLowerCase()) !== -1) {
          return true;
        }
      return false;
    });
  }

  toggleSelection(screenListObj: ScreenListObj) {
    screenListObj.selected = !screenListObj.selected;

    const result = this.selectedScreens.findIndex(scr => { return scr.id === screenListObj.screen.id; });

    // add or remove screen from selection list
    if (screenListObj.selected) {
      // make suer it's not already in there
      if (result === -1) {
        this.selectedScreens.push(screenListObj.screen);
      }
    } else {
      if (result !== -1) {
        this.selectedScreens.splice(result, 1);
      }
    }

  }


  addScreens() {
    this.showScreenPicker = !this.showScreenPicker;
  }

  openDialog() {
    this.showScreenPicker = false;
    this.visible = true;
  }

  closeDialog() {
    this.visible = false;
  }

  accept() {

    if (this.selectedScreens.length) {
      this.onSelected.emit(this.selectedScreens);
    }

    this.closeDialog();
  }

  closeScreenPicker() {
    this.showScreenPicker = false;
  }



}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/scheduling/components/addscreen-dialog/addscreen-dialog.component.ts